import { api } from "./axiosClient";
import type { Department } from "../types/department.types";

export const departmentsApi = {
  /** Upload links for a department's photos and documents (its own store). */
  initUpload: async (ids: string[], groupId?: string) => {
    const response = await api.post("/department/initupload", {
      ids,
      ...(groupId ? { groupId } : {}),
    });
    return response.data;
  },

  getMediaLink: async (ids: string[], size: number = 1, groupId?: string) => {
    const response = await api.post("/department/getmedialink", {
      ids,
      size,
      ...(groupId ? { groupId } : {}),
    });
    return response.data;
  },

  searchDepartments: async (payload: any) => {
    const response = await api.post("/department/search", payload);
    return response.data;
  },

  createDepartment: async (data: Partial<Department>) => {
    const response = await api.post("/department/create", data);
    return response.data;
  },

  updateDepartment: async (data: Partial<Department>) => {
    const response = await api.post("/department/edit", data);
    return response.data;
  },

  activateDepartment: async (id: string) => {
    return await api.post("/department/activate", { id });
  },

  deActivateDepartment: async (id: string) => {
    return await api.post("/department/deactivate", { id });
  },

  removeDepartment: async (id: string) => {
    return await api.post("/department/remove", { id });
  },
};
